import React, { useMemo } from 'react';
import styles from './download-knowledge-button.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from '../design-system';
import { colorPalette, Lang } from 'shared/constants';
import { Tooltip } from '../core';

const specialFormats = ['pptx', 'docx'];

export const DownloadKnowledgeButtonComponent = ({
  originalFormat,
  onDownloadPDF,
  onDownloadOriginal,
  lang = Lang.ACTION_BUTTON_TOOLTIPS,
}) => {
  const [visible, setVisible] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);
  const isSpecialFormat = specialFormats.includes(originalFormat);

  const items = useMemo(() => {
    const menuItems = [{ key: 'pdf', label: lang.OPEN_IN_NEW_TAB }];
    if (isSpecialFormat) {
      menuItems.push({
        key: 'special',
        label: lang.DOWNLOAD_ORIGINAL.replace('{format}', originalFormat.toUpperCase()),
      });
    }
    return menuItems;
  }, [isSpecialFormat, lang, originalFormat]);

  const handleSelect = key => {
    if (key === 'pdf') {
      onDownloadPDF();
    } else if (key === 'special') {
      onDownloadOriginal();
    }
    setVisible(false);
  };

  return (
    <Tooltip title={lang.DOWNLOAD_ITEM} open={isHovered && !visible}>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        onBlur={() => setIsHovered(false)}
      >
        <Dropdown
          items={items}
          onSelect={handleSelect}
          trigger={['click']}
          open={visible}
          onOpenChange={setVisible}
          childrenWrapperStyle={styles.buttonWrapper}
        >
          <FontAwesomeIcon icon={faFileArrowDown} size="2xl" color={colorPalette.primaryMain5} />
        </Dropdown>
      </div>
    </Tooltip>
  );
};
